import {
  Edit,
  SimpleForm,
  useRecordContext,
  ResourceContextProvider,
  useRedirect,
} from 'react-admin';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { FormFields } from './FormFields';

const EditBreadcrumbs = () => {
  const record = useRecordContext();
  const redirect = useRedirect();
  return (
    <Box sx={{ p: 2, backgroundColor: '#f8f9fa', borderRadius: 1, mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <Link
          underline="hover"
          component="button"
          variant="body1"
          onClick={() => redirect('/configuration')}
          sx={{ cursor: 'pointer' }}
        >
          Configuration
        </Link>
        <Link
          underline="hover"
          component="button"
          variant="body1"
          onClick={() => redirect('/configuration/forms')}
          sx={{ cursor: 'pointer' }}
        >
          Forms
        </Link>
        <Typography color="text.primary">
          {record?.name ? `Edit: ${record.name}` : 'Edit form'}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
};

const FormEditTitle = () => {
  const record = useRecordContext();
  if (!record) return null;
  return <span>Edit: {record.name}</span>;
};

export const FormsEdit = () => (
  <ResourceContextProvider value="forms">
    <Edit
      title={<FormEditTitle />}
      mutationMode="pessimistic"
      redirect={() => 'configuration/forms'}
    >
      <SimpleForm
        onKeyDown={(e) => {
          if (e.key === 'Enter' && e.target instanceof HTMLInputElement) {
            e.preventDefault();
          }
        }}
      >
        <EditBreadcrumbs />
        <FormFields />
      </SimpleForm>
    </Edit>
  </ResourceContextProvider>
);
